import { database } from './init'

const setScoreListener = (callback: (score: any)=>void) => {
  const scoreRef = database.ref('data/value/')
  scoreRef.on('value', snapshot => {
    callback(snapshot.val())
  })
}

export {setScoreListener}